//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create Notification ----------
export const setCurrentGameSession = (returnedPayload) => ({ type: ActionTypes.game.set_current_game_session, payload: returnedPayload });
export const updateCurrentGameSession = (returnedPayload) => ({ type: ActionTypes.game.update_current_game_session, payload: returnedPayload });
export const clearCurrentGameSession = (returnedPayload) => ({ type: ActionTypes.game.clear_current_game_session, payload: returnedPayload });

